// @flow
import {
    cond,
    compose,
    test,
    defaultTo,
    prop,
    take,
    T,
    map,
    keys,
    uniq,
    filter,
    values,
} from 'ramda';

import type {OneColorSizeType} from 'constants/flow/flowTypesProduct';

import {getProperty} from 'libs/utils/utils';

import {size} from './productToEECProduct';

const isKidsGlasses = compose(test(/Little Kids/), defaultTo(''), prop('frame_size_value'));

/**
 * Get frame size for product
 * @param {object} product - product item
 * @returns {string} - frame size product
 */
export const getFrameSize = cond([
    [isKidsGlasses, () => 'T'],
    [prop('variant'), prop('variant')],
    [getProperty('size.labelShort'), getProperty('size.labelShort')],
    [getProperty('frame.size.shortLabel'), getProperty('frame.size.shortLabel')],
    [T, compose(take(1), defaultTo(''), prop('frame_size_value'))],
]);

/**
 * Get a list of products with sizes
 * @param {OneColorSizeType} productOptions - object find size
 * @returns {Array<string>} - list of products with sizes
 */
export const getFrameSizeList = (productOptions: OneColorSizeType): Array<string> => {
    const acc = [];
    map((option: string) => {
        map(productSize => acc.push(productSize.size), productOptions[option].sizes);
    }, keys(productOptions));
    return uniq(acc);
};

/**
 * Get number of sizes for selected color
 * @param {OneColorSizeType} productOptions - object find size
 * @param {OneColorSizeType} id - selected color id
 * @returns {number} - quantity of sizes
 */
export const getSizeFrameShown = (productOptions: OneColorSizeType, id: number): number => {
    const shownFrame = filter(item => item.id === id, values(productOptions));

    return shownFrame.length ? size(shownFrame[0].sizes) : 0;
};
